import {
    _getStartStyle,
    _getElStyle,
    _showClearIcon,
    _getInputElStyle,
    _dropSingleCommonHtml,
    getInputWid,
    goClearInputIcon,
    goErrorInputIcon,
    getDownIconStr,
    _getLabelByValue
} from "./Common_Fun";

import {AssertUtils} from "goingutils";
import goAclWinUtils from "../../../jsCom/goForm/components/go-aclWin-ctl-event";

let GoAclWinCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else if (formType === "query") {
            return this.getQueryHtml(item, targetObj);
        } else {
            return this.getEditorHtml(item, targetObj);
        }
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (item, targetObj) {
        return _dropSingleCommonHtml(
            item,
            targetObj,
            "go-ctl-aclWin-drop",
            "ivu-icon ivu-icon-ios-arrow-down"
        );
    },
    getInitLable: function () {
    },
    //获取查询区域的html内容
    getQueryHtml: function (item, targetObj) {
        let {
            treeRelId,
            required,
            label,
            id,
            inputWidth = "auto"
        } = item;
        let iconClass = "ivu-icon ivu-icon-ios-arrow-down";
        let inputId = `${targetObj.prefixCls}_${id}`, dropType = "aclWin";
        return `<div class="row go-form-row flex-div go-ctl-aclWin" style="line-height: 26px;">
                <div class="go-label" style="${_getElStyle(targetObj)}"><span ${_getStartStyle({required}, targetObj)} class="start-require">*</span> ${label}：</div>
                <div class="go-content ${getInputWid(inputWidth)}" style="position: relative;">
                    <div class="input-group"  style="cursor: pointer;${_getInputElStyle(targetObj)}">
                    <input placeholder="输入或选择${label}"  id="${targetObj.prefixCls}_${id}" inputId="${targetObj.prefixCls}_${id}" ctl="auto" style="border-radius: 4px"  type="text"/>
                    ${goClearInputIcon(targetObj, id, treeRelId, 29)}
                    ${goErrorInputIcon(targetObj, id, treeRelId)}
                    ${getDownIconStr(targetObj, id, iconClass, inputId, dropType)}
                    </div>
                </div>
            </div>`;
    },
    //获取编辑区域的html内容
    getEditorHtml: function (item, targetObj) {
        let {
            treeRelId,
            required,
            label,
            id,
            inputWidth = "auto"
        } = item;
        let iconClass = "ivu-icon ivu-icon-ios-arrow-down";
        return `<div class="row go-form-row flex-div go-ctl-aclWin" style="line-height: 26px;">
                <div class="go-label" style="${_getElStyle(targetObj)}"><span ${_getStartStyle({required}, targetObj)} class="start-require">*</span> ${label}：</div>
                <div class="go-content ${getInputWid(inputWidth)}" style="position: relative;">
                    <div class="input-group"  style="cursor: pointer;${_getInputElStyle(targetObj)}">
                    <div  id="${targetObj.prefixCls}_${id}" inputId="${targetObj.prefixCls}_${id}" class="sel-item-container clearfix go-ctl-aclWin-drop" ctl="auto" style="border-radius: 4px 0 0 4px;">
                      <span class="initLabel placeholder" style="padding: 0">输入或选择${label}</span>
                      <ul class="content_body hidden"></ul>
                    </div>
                    ${goClearInputIcon(targetObj, id, treeRelId, 29)}
                    ${goErrorInputIcon(targetObj, id, treeRelId)}
                    ${getDownIconStr(targetObj, id, iconClass)}
                    </div>
                </div>
            </div>`;
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            goAclWinUtils.getQuerySubmitData(item, targetObj, backJson);
        } else {
            goAclWinUtils.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    setValue(prop, propValue, item, targetObj) {
        let label = _getLabelByValue(propValue, item.items);
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        if (AssertUtils.isNotEmpty(label)) {
            $("#" + inputElId).val(label);
            _showClearIcon(inputElId);
        }

        if (AssertUtils.isNotNull(item["treeRelId"])) {
            $(`#${inputElId}`)
                .prev()
                .val(propValue);
        }
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    itemTemp: function ({name = "", id = ""}) {
        return `<li class="choice-item" name="${name}" id="${id}"><span>${name}</span><i class="choice-close ivu-icon ivu-icon-md-close" type="md-close"></i></li>`;
    },
    //设置控件值
    __setValue(inputId, selIds, selNames) {
        var htmls = [];
        if (AssertUtils.isNotEmpty(selIds)) {
            selIds.forEach(function (item, index) {
                htmls.push(GoAclWinCtl.itemTemp({name: selNames[index], id: item}));
            });
        }
        if (htmls.length > 0) {
            $("#" + inputId)
                .find(".initLabel")
                .hide();
            $("#" + inputId)
                .find(".content_body")
                .html(htmls + "")
                .show();
        } else {
            $("#" + inputId)
                .find(".initLabel")
                .show();
            $("#" + inputId)
                .find(".content_body")
                .hide();
        }
        GoAclWinCtl.initCloseBtnEvent(inputId);
    },
    getShowValue(curVal) {
        return curVal || " ";
    },
    //注册删除事件
    initCloseBtnEvent(inputId) {
        $("#" + inputId + " .choice-close").click(function (event) {
            $(this)
                .closest(".choice-item")
                .remove();
            //显示提示语
            if ($("#" + inputId + " .choice-close").length === 0) {
                $("#" + inputId)
                    .find(".initLabel")
                    .show();
                $("#" + inputId)
                    .find(".content_body")
                    .hide();
            }
            event.stopPropagation();
        });
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        //初始化编辑状态下的事件
        goAclWinUtils.initEditorEvent(parentObj, targetObj, vueObj);
        //初始化查询状态下的事件
        goAclWinUtils.initQueryEvent(parentObj, targetObj, vueObj);
        //初始化单查询状态下的事件
        goAclWinUtils.initSingleQueryEvent(parentObj, targetObj, vueObj);
    }
};
export default GoAclWinCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-aclWin-ctl.js